//GET /{catalog name}
export const REQUEST_GET_STYLES = 'REQUEST_GET_STYLES';
export const GET_STYLES_SUCCESS = 'GET_STYLES_SUCCESS';
export const GET_STYLES_FAILURE = 'GET_STYLES_FAILURE';
